module.exports = __webpack_public_path__ + "static/img/qrcode-2.8ce70795.png";